import { GRID } from './canvas';

export const applyBorder = (ctx: CanvasRenderingContext2D, color: string): void => {
  const r = parseInt(color.slice(1, 3), 16);
  const g = parseInt(color.slice(3, 5), 16);
  const b = parseInt(color.slice(5, 7), 16);
  const img = ctx.getImageData(0, 0, GRID, GRID);
  const data = img.data;
  const out = new Uint8ClampedArray(data);
  for (let y = 0; y < GRID; y++) for (let x = 0; x < GRID; x++) {
    const i = (y * GRID + x) * 4;
    if (data[i + 3] !== 0) continue;
    let opaque = false;
    if (x > 0 && data[i - 4 + 3] !== 0) opaque = true;
    else if (x < GRID - 1 && data[i + 4 + 3] !== 0) opaque = true;
    else if (y > 0 && data[i - GRID * 4 + 3] !== 0) opaque = true;
    else if (y < GRID - 1 && data[i + GRID * 4 + 3] !== 0) opaque = true;
    if (opaque) { out[i] = r; out[i + 1] = g; out[i + 2] = b; out[i + 3] = 255; }
  }
  ctx.putImageData(new ImageData(out, GRID, GRID), 0, 0);
};
